import type { ScreenInventoryVolumetry } from 'sonata-static-storage/lib/common/common.types';

type Props = {
  volumetry: ScreenInventoryVolumetry;
};

type ItemProps = {
  adTypeCode: string;
};

const iconDictionary: Record<string, string> = {
  audio: 'fa-light fa-volume-low',
  display: 'fa-regular fa-image',
  html5: 'fa-sharp fa-regular fa-arrow-pointer',
  video: 'fa-regular fa-clapperboard-play'
};

function AllowedAdTypesVolumetryItem({ adTypeCode }: ItemProps) {
  return (
    <div className="doohInventoryMapVolumetry__metric">
      <span className="doohInventoryMapVolumetry__metricValue">
        <i className={iconDictionary[adTypeCode]} />
      </span>
      <span className="doohInventoryMapVolumetry__metricName">{adTypeCode.toUpperCase()}</span>
    </div>
  );
}

export default function AllowedAdTypesVolumetry({ volumetry }: Props) {
  const sortedAllowedAdTypes = [...volumetry.allowedAdTypes].sort((a, b) => a.localeCompare(b));

  return sortedAllowedAdTypes.map(adTypeCode => (
    <AllowedAdTypesVolumetryItem adTypeCode={adTypeCode} key={`countryVolumetry-${adTypeCode}`} />
  ));
}
